import { Components } from '@mui/material'

const MuiCssBaseline: Components['MuiCssBaseline'] = {}

export default MuiCssBaseline
